// 所有接口
import api from '@/api';

//获取cookie中的值
export const getCookieValue = (name)=>{
  let cookies = document.cookie.split(";");
  let cookieValue = '';
  cookies.length && cookies.forEach(item=>{
    let items = item.split("=");
    if(items[0].trim()===name){
      cookieValue = items[1].trim();
    }
  })
  return cookieValue
}


//【JWT】检测是否有JWT并检测是否过期
export const checkJWTValue = async (url)=>{
  return new Promise(async (resolve,reject)=>{
    let CookieAuthorization = await getCookieValue('_t'); //jwt
    let CookieAuthorizationEndTime = await getCookieValue('_t_at'); //jwt的过期时间
    let AuthorizationEndTime = parseInt(new Date().getTime()/1000) + 7*24*60*60;

    if(!CookieAuthorization || !CookieAuthorizationEndTime){
      //没有jwt || 没有过期时间
      //执行退出登录
      resolve({
        Authorization:''
      });
      localStorage.setItem('_c_t', '');
      return false;
    }
    //判断是否需要更新jwt
    let refreshJwtUrl = '/v3/jwts';
    let updateUserJwt = CookieAuthorizationEndTime <= AuthorizationEndTime;

    if(updateUserJwt && url && !url.includes(refreshJwtUrl)){
      let jwtRes = await api.jwt.refreshJwt({
        jwt:CookieAuthorization
      });
      if(jwtRes.code === 1000){
        let { jwt, jwt_timestamp } = jwtRes.data;
        await updateJWT({
          jwt:jwt,
          jwt_timestamp:jwt_timestamp
        })
        //更新jwt
        resolve({
          Authorization:jwt
        });
      }else if(jwtRes.code === 2012){
        //删除jwt
        await updateJWT({
          jwt:'',
          jwt_timestamp:parseInt(new Date().getTime()/1000)+1
        })
        localStorage.setItem('_c_t', '');
        resolve({
          Authorization: ''
        });
      }else{
        //更新jwt
        resolve({
          Authorization:CookieAuthorization || ''
        });
      }

    }else{
      resolve({
        Authorization:CookieAuthorization
      });
    }

  })


}

//【JWT】更新jwt时间
export const updateJWT = async (data)=>{
  let { jwt, jwt_timestamp='' } = data;
  if(typeof jwt !== 'string'){
    return false;
  }
  let { pathname, hostname } = window.location;
  let endData = new Date();
      if(jwt_timestamp){
        endData.setTime(jwt_timestamp*1000);//过期时间
      }else{
        jwt_timestamp = parseInt(endData.getTime()/1000) + 14 * 24 * 60 * 60;
        endData.setTime(endData.getTime() + 14 * 24 * 60 * 60 * 1000);//过期时间 14天
      }
  document.cookie = `_t=${jwt}; domain=${hostname.split('.')[1]}.${hostname.split('.')[2]}; expires=${endData.toGMTString()};  path=/`
  document.cookie = `_t_at=${jwt_timestamp}; domain=${hostname.split('.')[1]}.${hostname.split('.')[2]}; expires=${endData.toGMTString()};  path=/`

}


// 跳转登录方法
export const toLogin=({url,login})=>{
  //增加登录之后自动跳转活到相应页面。过期时间1小时
  if(process.env.VUE_APP_EVN === 'sandbox' || process.env.VUE_APP_EVN === 'staging_sandbox'){
    return
  }
  var exp = new Date();
  exp.setTime(exp.getTime() + 30 * 24 * 60 * 60 * 1000);//过期时间 30天
  let { pathname, hostname } = window.location;
  document.cookie = `_r_b_t=${url || encodeURIComponent(window.location.href)}; domain=${hostname.split('.')[1]}.${hostname.split('.')[2]}; expires=${exp.toGMTString()}; path=/`
  if(login){
    window.location.href = '/auth-signin';
  }
}
